/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type StopPendingDeletionMutationVariables = Types.Exact<{
  input: Types.StopPendingDeletionInput
}>

export type StopPendingDeletionMutation = {
  __typename?: 'Mutation'
  stopPendingDeletion: {
    __typename?: 'StopPendingDeletionResponse'
    success: boolean
  }
}

export const StopPendingDeletionDocument = gql`
    mutation stopPendingDeletion($input: StopPendingDeletionInput!) {
  stopPendingDeletion(input: $input) {
    success
  }
}
    `
export type StopPendingDeletionMutationFn = Apollo.MutationFunction<
  StopPendingDeletionMutation,
  StopPendingDeletionMutationVariables
>

/**
 * __useStopPendingDeletionMutation__
 *
 * To run a mutation, you first call `useStopPendingDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopPendingDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopPendingDeletionMutation, { data, loading, error }] = useStopPendingDeletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopPendingDeletionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StopPendingDeletionMutation,
    StopPendingDeletionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StopPendingDeletionMutation,
    StopPendingDeletionMutationVariables
  >(StopPendingDeletionDocument, options)
}
export type StopPendingDeletionMutationHookResult = ReturnType<
  typeof useStopPendingDeletionMutation
>
export type StopPendingDeletionMutationResult =
  Apollo.MutationResult<StopPendingDeletionMutation>
export type StopPendingDeletionMutationOptions = Apollo.BaseMutationOptions<
  StopPendingDeletionMutation,
  StopPendingDeletionMutationVariables
>
